<tiime-dialog [isLoading]="isLoading()" (cancel)="cancel()">
  <span mat-dialog-title>Historique des modifications - {{ title }}</span>
  <tiime-sticky-table-container [containerState]="storeContainerState$ | async" mat-dialog-content>
    <div tiimeContainerHeader>
      <div tiimeContainerHeaderLeft></div>
      <div tiimeContainerHeaderRight>
        <tiime-paginator
          [range]="range$ | async"
          [disabled]="storeContainerState$ | async | map: mapToDisabledPaginator"
          (rangeEvent)="applyRange($event)"
        ></tiime-paginator>
        <tiime-table-loader [isLoading]="storeIsLoading$ | async"></tiime-table-loader>
      </div>
    </div>
    <div tiimeContainerContent #scrollContainer>
      <app-entity-history-table [audits]="audits$ | async" [statusType]="statusType"></app-entity-history-table>
    </div>
  </tiime-sticky-table-container>
</tiime-dialog>
